import { useState } from "react";
import { Button, Form, FormProps, Modal } from "semantic-ui-react";
import { ModalControlData } from "../hooks/commonHooks";
import { useFormData } from "../hooks/formHooks";
import { restRequest } from "../http";
import { ChangePasswordData } from "../models/user_model";
import { fieldError } from "../utils";

export function ChangePassword(props: { modelControl: ModalControlData, onFinish: (data: ChangePasswordData) => void }) {
    const { modelControl, onFinish } = props;

    const [data, setField, setData] = useFormData<ChangePasswordData>({} as any);
    const [invalidError, setInvalidError] = useState<any>({});
    const [loading, setLoading] = useState(false);

    const onSubmit = (event: React.FormEvent<HTMLFormElement>, formProps: FormProps) => {
        event.preventDefault();

        setLoading(true);

        restRequest<ChangePasswordData>('auth/password', data, 'post').then(result => {
            props.onFinish(result);
            setInvalidError({});
        }, resp => {
            if (resp.status === 2) {
                setInvalidError(resp.data);
            }
        }).finally(() => setLoading(false));
    }

    return <>
        <Modal {...props.modelControl.props} size="large">
            <Modal.Header>Change Your Password</Modal.Header>
            <Modal.Content>
                <Form onSubmit={onSubmit} loading={loading}>
                    <Form.Group widths="equal">
                        <Form.Input label="Current Password" type="password" name="old_password" value={data['old_password'] || ''} onChange={setField} required error={fieldError('old_password', invalidError)}>
                        </Form.Input>
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Input label="New Password" type="password" name="password" value={data['password'] || ''} onChange={setField} required error={fieldError('password', invalidError)}>
                        </Form.Input>
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Input label="Confirm New Password" type="password" name="confirm_password" value={data['confirm_password'] || ''} onChange={setField} required error={fieldError('confirm_password', invalidError)}>
                        </Form.Input>
                    </Form.Group>
                    <div>
                        <Button primary>Submit</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Button as="a" onClick={e => props.modelControl.setOpen(false)}>Cancel</Button>
                    </div>
                </Form>
            </Modal.Content>
        </Modal>
    </>
}